/**
 * TopBannerAd
 * ─────────────────────────────────────────────────────
 * Renders the 728×90 leaderboard banner ad from highperformanceformat.com
 * at the very top of every page content area.
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const BANNER_SCRIPT_SRC =
  'https://www.highperformanceformat.com/54b7aea6966a4019ae8c4d79d6e0a9e6/invoke.js';
const BANNER_KEY = '54b7aea6966a4019ae8c4d79d6e0a9e6';

const EXCLUDED_PATHS = ['/about', '/privacy', '/terms'];

export const TopBannerAd = () => {
  const { pathname } = useLocation();
  const containerRef = useRef(null);

  useEffect(() => {
    if (EXCLUDED_PATHS.includes(pathname)) return;
    const container = containerRef.current;
    if (!container) return;

    container.innerHTML = '';

    window.atOptions = {
      key: BANNER_KEY,
      format: 'iframe',
      height: 90,
      width: 728,
      params: {},
    };

    const script = document.createElement('script');
    script.src = BANNER_SCRIPT_SRC;
    script.async = true;
    container.appendChild(script);

    const interval = setInterval(() => {
      if (!container) return;
      const bodyIframes = [...document.body.children].filter(
        (el) => el.tagName === 'IFRAME' && (el.width === '728' || el.src?.includes('highperformanceformat'))
      );
      bodyIframes.forEach((iframe) => {
        iframe.style.display = 'block';
        iframe.style.maxWidth = '100%';
        iframe.style.margin = '0 auto';
        container.appendChild(iframe);
      });
    }, 1000);

    return () => {
      clearInterval(interval);
      if (container) container.innerHTML = '';
    };
  }, [pathname]);

  if (EXCLUDED_PATHS.includes(pathname)) return null;

  return (
    <div
      aria-label="Advertisement"
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '12px 0 14px',
        marginBottom: '8px',
        borderBottom: '1px solid var(--border-color)',
        background: 'var(--bg-secondary)',
      }}
    >
      <div
        ref={containerRef}
        id="top-banner-ad-container"
        style={{
          width: '100%',
          maxWidth: '728px',
          minHeight: '90px',
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '8px',
          background: 'transparent',
          margin: '0 auto',
        }}
      />

      <span
        style={{
          marginTop: '5px',
          fontSize: '0.6rem',
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: 'var(--text-muted)',
          opacity: 0.45,
          userSelect: 'none',
        }}
      >
        Advertisement
      </span>
    </div>
  );
};

export default TopBannerAd;
